import { WarningOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";

type Props = {
  warnings: string[];
  className?: string;
}

const WarningsTooltip = ({ warnings, className }: Props) => (
  <Tooltip styles={{ root: { whiteSpace: "pre-line" }}} title={warnings.join("\n")} className={className}>
    <WarningOutlined />
  </Tooltip>
);

export default WarningsTooltip;
